import { Sliders } from 'lucide-react';

export function SettingsMain() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Sliders className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold">Settings</h1>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Application settings coming soon...</p>
      </div>
    </div>
  );
}
